import React, { Component, Fragment } from 'react'
import {
  ReportTable,
  CustomSelect,
  CustomTabPane,
  HeaderTabs,
  SearchEventMargin,
  PaginationRightAligned
} from '../../styled.js'
import { Tabs, Icon, Row, Col, Pagination, Divider, Button } from 'antd'
import { generateCSV } from '../../../../utils.js'
import moment from 'moment/moment'
import '../../Report/style.css'
import { isSafari } from 'react-device-detect'
import { withTranslation } from 'react-i18next'
import { Search, RenderArrows } from '../../../../components/index.js'
import _ from 'lodash'
import ReportHeader from '../../components/ReportHeader.jsx'
import TypeSelect from '../../components/TypeSelect.jsx'
import { report } from '../../../../constants/index.js'

const { TabPane } = Tabs
const { Option } = CustomSelect

const types = {
  allTime: '5',
  today: '1',
  week: '7',
  month: '30',
  year: '12',
  other: '2'
}

const reverseDateType = {
  5: 'all',
  1: 'today',
  7: 'week',
  30: 'month',
  12: 'year',
  2: 'other'
}

const columns = t => [
  {
    title: t('v4:maze'),
    dataIndex: 'cover',
    render: cover => {
      return (
        <img
          style={{ width: '70px', height: '50px' }}
          src={cover?.resizes?.thumbnail || cover?.link}
          alt="cover"
        />
      )
    },
    width: 70
  },
  {
    dataIndex: 'title',
    textWrap: 'word-break'
  },
  {
    title: t('reports:created_date'),
    dataIndex: 'created_at',
    render: x => {
      if (!x) return 'N/A'
      return moment(x).format('ll')
    },
    sorter: (a, b) => new Date(a.created_at) - new Date(b.created_at),
    sortDirections: ['descend', 'ascend']
  },
  {
    title: t('reports:status'),
    dataIndex: 'status',
    sorter: (a, b) => a.status.length - b.status.length,
    sortDirections: ['descend', 'ascend']
  },
  // {
  //   title: t('reports:participants'),
  //   dataIndex: 'participants',
  //   sorter: (a, b) => a.status.length - b.status.length,
  //   sortDirections: ['descend', 'ascend']
  // },
  {
    title: t('v4:avg_score'),
    dataIndex: 'averageScore',
    sorter: (a, b) => a.averageScore - b.averageScore,
    sortDirections: ['descend', 'ascend']
  },
  {
    title: t('reports:views'),
    dataIndex: 'session_play',
    sorter: (a, b) => a.session_play - b.session_play,
    sortDirections: ['descend', 'ascend']
  },
  {
    title: t('reports:completed'),
    dataIndex: 'completed',
    sorter: (a, b) => a.completed - b.completed,
    sortDirections: ['descend', 'ascend']
  }
]

class Details extends Component {
  _isMount = false
  state = {
    search: '',
    dateType: '5',
    workshopSearchType: '',
    sortBy: '',
    dateFrom: null,
    dateTo: null,
    page: report.PAGE_NUMBER,
    pageSize: report.PAGE_SIZE
  }

  componentDidMount() {
    this._isMount = true
    const { pageSize, page } = this.state
    const state = this.props.history.location.state
    console.log('stae', state)
    if (state && state.searchType) {
      this.setState(
        {
          dateType: types[state.searchType],
          workshopSearchType: state.searchType,
          dateFrom: state.dateFrom,
          dateTo: state.dateTo
        },
        () => {
          if (state.dateFrom && state.dateTo !== '') {
            this.fetchData()
          } else {
            this.handleSortByChange(types[state.searchType])
          }
        }
        // () => this.getReport()
      )
      return
    }

    this.props.getMazeReport({
      mode: 'report',
      offset: this.createOffset(page, pageSize),
      limit: pageSize,
      date: 'allTime',
      searchByTitle: '',
      from: '',
      to: ''
    })

    // this.getReport()
  }

  download = () => {
    const {
      list: { total = [] }
    } = this.props.reports.reportMazes
    const dataCSV = total.map((x, index) => {
      return {
        id: index,
        title_maze: x.title,
        created_at: moment(x.created_at),
        status: x.status,
        score: x.averageScore,
        views: x.session_play,
        completed: x.completed
      }
    })
    const header = [
      '#',
      'Title',
      'Created At',
      'Status',
      'Percentage Score',
      'Views',
      'Completed'
    ]
    if (!isSafari) {
      let ele = document.createElement('a')
      ele.setAttribute(
        'href',
        'data:text/csv;charset=utf-8,' +
          encodeURIComponent(generateCSV(dataCSV, header))
      )
      ele.setAttribute('download', 'maze-report.csv')
      document.body.appendChild(ele)
      ele.click()
      // generateCSV(dataCSV, header)
    } else {
      let ele = document.createElement('a')
      ele.setAttribute(
        'href',
        'data:text/csv;charset=utf-8,' +
          encodeURIComponent(generateCSV(dataCSV, header))
      )
      ele.setAttribute('download', 'maze-report.csv')
      ele.click()
    }
  }

  componentWillUnmount() {
    this._isMount = false
  }

  onSearch = _.debounce(value => {
    if (this._isMount) {
      const { sortBy, dateFrom, dateTo } = this.state
      this.setState(
        {
          search: value
        },
        () => {
          this.props.getMazeReport({
            mode: 'report',
            offset: 0,
            limit: 10,
            // date: this.state.dateType,
            searchByTitle: value,
            date: sortBy === 'other' ? '' : sortBy,
            from: sortBy === 'other' ? dateFrom : '',
            to: sortBy === 'other' ? dateTo : ''
          })
        }
      )
    }
  }, 1000)

  // handleSortByChange = value => {
  //   const { search, sortBy, page ,pageSize } = this.state
  //   this.setState({
  //     sortBy: reverseDateType[value] ,
  //     dateType: value ,
  //   },
  //   () => this.getReport({
  //       offset: this.createOffset(page, pageSize),
  //       limit: pageSize,
  //       searchByTitle: search,
  //       date: reverseDateType[value] ,
  //       from: '',
  //       to: '',
  //   }))
  // }

  getReport = params => {
    const { page, pageSize, search } = this.state
    this.props.getMazeReport({
      mode: 'report',
      offset: this.createOffset(page, pageSize),
      limit: pageSize,
      date: params && params.date,
      from: '',
      to: '',
      searchByTitle: search
    })
  }

  handleSortByChange(value) {
    if (value === '1') {
      if (this._isMount) {
        this.setState(
          {
            sortBy: 'today',
            dateType: value
          },
          () => {
            this.getReport({
              date: 'today'
            })
          }
        )
      }
    } else if (value === '7') {
      if (this._isMount) {
        this.setState(
          {
            sortBy: 'week',
            dateType: value
          },
          () => {
            this.getReport({
              date: 'week'
            })
          }
        )
      }
    } else if (value === '30') {
      if (this._isMount) {
        this.setState(
          {
            sortBy: 'month',
            dateType: value
          },
          () => {
            this.getReport({
              date: 'month'
            })
          }
        )
      }
    } else if (value === '12') {
      if (this._isMount) {
        this.setState(
          {
            sortBy: 'year',
            dateType: value
          },
          () => {
            this.getReport({
              date: 'year'
            })
          }
        )
      }
    } else if (value === '5') {
      if (this._isMount) {
        this.setState(
          {
            sortBy: 'all',
            dateType: value
          },
          () => {
            this.getReport({
              date: 'all'
            })
          }
        )
      }
    } else if (value === '2') {
      if (this._isMount) {
        this.setState({
          sortBy: 'other',
          dateType: value
        })
      }
    }
  }

  createOffset = (page, pageSize) => page * pageSize - pageSize

  onChangePagination = page => {
    const {
      pageSize,
      workshopSearchType,
      search,
      dateType,
      dateFrom,
      dateTo
    } = this.state
    this.setState(
      {
        page: page,
        pageSize: pageSize
      },
      () => {
        this.props.getMazeReport({
          mode: 'report',
          offset: this.createOffset(page, pageSize),
          limit: pageSize,
          ...(workshopSearchType && {
            date: workshopSearchType === 'allTime' ? 'all' : workshopSearchType
          }),
          searchByTitle: search,
          date:
            reverseDateType[dateType] === 'other'
              ? ''
              : reverseDateType[dateType],
          from: reverseDateType[dateType] === 'other' ? dateFrom : '',
          to: reverseDateType[dateType] === 'other' ? dateTo : ''
        })
      }
    )
  }

  handleDate = val => {
    this.setState(
      {
        dateFrom: val[0],
        dateTo: val[1]
      },
      this.fetchData
    )
  }

  fetchData = () => {
    const { search, pageSize, page, dateFrom, dateTo } = this.state
    this.props.getMazeReport({
      mode: 'report',
      offset: this.createOffset(page, pageSize),
      limit: pageSize,
      date: 'other',
      from: dateFrom,
      to: dateTo,
      searchByTitle: search
    })
  }

  callbackTabClicked = (key, event) => {
    if (key === '0') {
      this.props.history.push(`/reports`)
    } else if (key === '2') {
      this.props.history.push('/reports', 'user')
    }
  }

  render() {
    const {
      reports: {
        reportMazes: {
          list: { total, pagination },
          fetch: reportFetch
        }
      },
      t
    } = this.props
    const { dateType, page, pageSize, dateFrom, dateTo } = this.state
    const mazes = reportFetch ? [] : total
    const totalData = pagination ? pagination.total : 0

    return (
      <Fragment>
        <div className="content-warp">
          <div
            className="report-warp sharelook-table"
            style={{ direction: 'ltr' }}
          >
            {/* <Button
              className="download-report"
              onClick={this.download}
              type="primary"
            >
              {t('reports:report_download')}
            </Button> */}

            <HeaderTabs
              defaultActiveKey="1"
              animated={false}
              onChange={this.changeTab}
              onTabClick={this.callbackTabClicked}
              // onTabClick={key => {
              //   if (key === '0') {
              //     this.props.history.push(`/reports`)
              //   }
              // }}
              tabBarExtraContent={
                <ReportHeader
                  workshopDateType={dateType}
                  dateChange={value => this.handleSortByChange(value)}
                  download={this.download}
                  handleDate={(date, dateString) => this.handleDate(dateString)}
                  dateFrom={dateFrom}
                  dateTo={dateTo}
                  // backToDashboard={e => this.props.history.push('/reports')}
                />
              }
            >
              <TabPane
                tab={
                  <CustomTabPane>
                    <Icon type="left" style={{ fontSize: '18px' }} />
                  </CustomTabPane>
                }
                key="0"
              />
              <TabPane tab={t('reports:workshop_report')} key="1">
                {/* <Row>
                  <Col span={8} />
                  <Col span={7} />
                  <Col span={3}>
                    <CustomSelect
                      margin
                      value={dateType}
                      onChange={value => this.handleSortByChange(value)}
                    >
                      <Option value="allTime">{t('reports:all_time')}</Option>
                      <Option value="today">{t('reports:today')}</Option>
                      <Option value="week">{t('reports:seven_days')}</Option>
                      <Option value="month">{t('reports:this_month')}</Option>
                      <Option value="year">{t('reports:one_year')}</Option>
                    </CustomSelect>
                  </Col>
                  <Col span={6}>
                    <SearchEventMargin>
                      <Search
                        placeholder={t('v4:search_maze')}
                        onChange={e => this.onSearch(e.target.value)}
                      />
                    </SearchEventMargin>
                  </Col>
                </Row> */}
                <TypeSelect defaultValue="maze" />
                <Row>
                  <ReportTable
                    rowKey="id"
                    columns={columns(t)}
                    dataSource={mazes}
                    loading={reportFetch}
                    borderRadius
                    pagination={false}
                    // pagination={{
                    //   itemRender: RenderArrows,
                    //   pageSize: 10
                    // }}
                    onRow={(record, rowIndex) => {
                      return {
                        onClick: e =>
                          this.props.history.push(`/reports/maze/` + record.id)
                      }
                    }}
                    title={() => (
                      <>
                        <Row
                          className="sharelook-course-wrapper"
                          style={{ marginLeft: '30px', marginTop: '3px' }}
                        >
                          <Col span={5}>
                            <SearchEventMargin>
                              <Search
                                placeholder={t('v4:search_maze')}
                                onChange={e => this.onSearch(e.target.value)}
                              />
                            </SearchEventMargin>
                          </Col>
                          <Col span={11} />
                          <Col className="report-title" span={3} push={1}>
                            {t('v4:total')} {totalData ? totalData : '0'}{' '}
                            {t('v4:maze').toUpperCase()}
                          </Col>
                          <Col span={4} style={{ marginTop: '14px' }}>
                            <PaginationRightAligned margin>
                              <Pagination
                                total={totalData}
                                current={page}
                                pageSize={pageSize}
                                onChange={this.onChangePagination}
                                simple
                              />
                            </PaginationRightAligned>
                          </Col>
                        </Row>
                        <Divider style={{ margin: '0px' }} />
                      </>
                    )}
                  />
                </Row>
              </TabPane>
              <TabPane tab={t('reports:user_report')} key="2"></TabPane>
              <TabPane tab={t('v4:marketplace_report')} key="3"></TabPane>
            </HeaderTabs>
          </div>
        </div>
      </Fragment>
    )
  }
}

export default withTranslation('report')(Details)
